/**
 * Browser-side memory of "a pilot shared this link with me".
 *
 * A share link can land on any page, so the code is parked in local storage
 * and picked up whenever the visitor finally RSVPs.
 */

const KEY = "sf_ref_code";

export function normalizeRefCode(raw: string | null | undefined): string | null {
  const clean = (raw ?? "").trim().toUpperCase();
  if (!clean || clean.length > 32 || !/^[A-Z0-9]+$/.test(clean)) return null;
  return clean;
}

export function storeRefCode(raw: string | null | undefined): void {
  const code = normalizeRefCode(raw);
  if (!code) return;
  try {
    globalThis.localStorage?.setItem(KEY, code);
  } catch {
    /* private browsing — the link still works, it just isn't remembered */
  }
}

export function readStoredRefCode(): string | null {
  try {
    return normalizeRefCode(globalThis.localStorage?.getItem(KEY));
  } catch {
    return null;
  }
}

export function clearRefCode(): void {
  try {
    globalThis.localStorage?.removeItem(KEY);
  } catch {
    /* nothing to do */
  }
}
